<div class="tab-content" id="pills-tabContent-MyFinance">
  <div id="pills-TataOk" role="tabpanel" aria-labelledby="pills-TataOk-tab">
    <div class="card-list mb-3">
      <div class="card status-card approve" *ngFor="let item of bookingData | paginate: {
        itemsPerPage: itemsPerPage,
        currentPage: currentPageBooking,
        totalItems: totalItemsBooking,
        id: 'booking'
      };let id = index">
        <div class="card-body">
          <div class="list-group list-group-horizontal">
            <div class="list-group-item">
              <p class="title">Vehicle Price</p>
              <div class="price">{{item?.vehicle_price | currency:'INR':'symbol':'4.0-0'}}</div>
            </div>
            <div class="list-group-item ms-auto" style="cursor: pointer;"></div>
            <div class="list-group-item ms-auto">
              <p class="title  d-md-block">
                Registration No:
                <span class="" >
                  {{ item?.vehicle_reg_no }}
                </span>
              </p>
              <!-- <div class="more text-end">
                <a
                  (click)="toggleDetails(financeData?.request_id, recordId, 'expandDetails');fetchVehicleData(financeData);
                  fetchDealerInfo(financeData?.vehicle_specs, financeData?.division_code, viewFlag, recordId);
                  fetchLeadStatus(financeData?.request_id, recordId);
                  fetchReviewStatus(financeData?.vehicle_specs, financeData?.division_code, financeData?.vehicle_code, recordId);">

                  <span class="d-none d-md-inline-block" *ngIf="viewFlag == 'secure'">More Details</span>
                  <span class="d-none d-md-inline-block" *ngIf="viewFlag == 'expandDetails'">
                    {{ activeRecordId !== recordId ? 'More Details' : 'Less Details' }}
                  </span>
                  <span class="d-inline-block">
                    <img [src]='environment1 + "assets/images/new-images/rightArrowdarkBlue.svg"'
                      alt="rightArrowdarkBlue" loading="lazy">
                  </span>

                </a>
              </div> -->
              <div class="more text-end">
                <p class="title d-md-block">
                  <span class="" >
                    {{ item?.vehicle_dealer_name }}
                  </span>
                </p>
              </div>
            </div>
          </div>
          <!-- Vehicle Details -->
          <div class="card-content">
            <div class="prod-item">
              <div class="prod-img">
                <a [routerLink]="redirect(item?.vehicle_id)">
                  <img [src]="item?.vehicle_image" class="img-fluids cursor" alt="product IMg" height="64" width="112"
                    loading="lazy" (error)="setDefaultImage($event)"
                    >

                </a>
              </div>
              <div class="prod-info">
                <a [routerLink]="redirect(item?.vehicle_id)">
                  <div class="title cursor">
                    {{item?.vehicle_model}}
                  </div>
                </a>
                <div class="prod-price-quantity">
                  <!-- <div class="price">
                    {{item.vehicle_price?
                    (item.vehicle_price |currency:'INR':'symbol':'4.0-0') :
                    item.vehicle_price ?
                    (item.vehicle_price
                    |currency:'INR':'symbol':'4.0-0') : '-'}}</div> -->
                    <div class="qty">Fuel Type:<span>{{item.vehicle_fuel_type}}</span>
                    </div>
                  <div class="qty">QTY:<span>{{item.vehicle_qty}}</span>
                  </div>
                  <div class="qty">Vehicle Price:<span>{{
                      item.vehicle_price?
                      (item.vehicle_price|currency:'INR':'symbol':'4.0-0') : "-" }}</span>
                  </div>
                  <div class="qty">
                    State(District):
                    <span *ngIf="item.vehicle_state_name && item.vehicle_district">
                      {{ item.vehicle_state_name }} ({{ item.vehicle_district }})
                    </span>
                    <span *ngIf="item.vehicle_state_name && !item.vehicle_district">
                      {{ item.vehicle_state_name }}
                    </span>
                    <span *ngIf="!item.vehicle_state_name && item.vehicle_district">
                      {{ item.vehicle_district }}
                    </span>
                    <span *ngIf="!item.vehicle_state_name && !item.vehicle_district"></span>
                  </div>
                  
                </div>
              </div>
            </div>

          </div>
        </div>
        <!--order details web view-->
        <div class="ps-3 pe-3">
          <div>
            <div class="rounded-0 border-top progress-box" *ngIf="item?.lead_stages_history.length > 0">
              <ul class="progressbar">
                <li [class.active]="isStageReached('UV-C0 (Prospecting)', item.lead_stages_history)">
                  <span class="step-desc">Request Accepted</span>
                  <span class="step-date">
                    {{ getStageDate('UV-C0 (Prospecting)', item.lead_stages_history) | date:'dd-MM-yyyy' }}
                  </span>
                </li>
              
                <li *ngIf="isStageReached('Closed Lost at UV-C0', item.lead_stages_history)" [class.reject]="true">
                  <span class="step-desc">Closed Lost at C0</span>
                  <span class="step-date">
                    {{ getStageDate('Closed Lost at UV-C0', item.lead_stages_history) | date:'dd-MM-yyyy' }}
                  </span>
                </li>
              
                <li [class.active]="isStageReached('UV-C1 (Quote Tendered)', item.lead_stages_history)">
                  <span class="step-desc">Quote Tendered</span>
                  <span class="step-date">
                    {{ getStageDate('UV-C1 (Quote Tendered)', item.lead_stages_history) | date:'dd-MM-yyyy' }}
                  </span>
                </li>
              
                <li *ngIf="isStageReached('Closed Lost at UV-C1', item.lead_stages_history)" [class.reject]="true">
                  <span class="step-desc">Closed Lost at C1</span>
                  <span class="step-date">
                    {{ getStageDate('Closed Lost at UV-C1', item.lead_stages_history) | date:'dd-MM-yyyy' }}
                  </span>
                </li>
              
                <li [class.active]="isStageReached('UV-C2 (Adv. Received)', item.lead_stages_history)">
                  <span class="step-desc">Papers Submitted</span>
                  <span class="step-date">
                    {{ getStageDate('UV-C2 (Adv. Received)', item.lead_stages_history) | date:'dd-MM-yyyy' }}
                  </span>
                </li>
              
                <li *ngIf="isStageReached('Closed Lost at UV-C2', item.lead_stages_history)" [class.reject]="true">
                  <span class="step-desc">Closed Lost at C2</span>
                  <span class="step-date">
                    {{ getStageDate('Closed Lost at UV-C2', item.lead_stages_history) | date:'dd-MM-yyyy' }}
                  </span>
                </li>
              
                <li [class.completed]="isStageReached('UV-C3 (Vehicle Delivered)', item.lead_stages_history)">
                  <span class="step-desc">Delivered</span>
                  <span class="step-date">
                    {{ getStageDate('UV-C3 (Vehicle Delivered)', item.lead_stages_history) | date:'dd-MM-yyyy' }}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        

        <!-- Footer -->
        <!-- <div class="card-footer text-white">
          <div class="row justify-content-between align-items-center">
            <div class="col">
              <p class="mb-0">SECURE YOUR VEHICLE FOR LONGER WITH OUT VALUE ADDED SERVICES</p>
            </div>
            <div class="col-auto">
              <button class="btn secure-now-btn">Secure Now ></button>
            </div>
          </div>
        </div> -->
      </div>


      <!--no booking-->
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 empty-states" *ngIf="bookingData?.length == 0">
        <img [src]='environment1 + "assets/images/no_vehicle_booked.svg"' loading="lazy">
        <h3>
          No Vehicles Booked
        </h3>
        <div class="desc">
          You haven’t booked any vehicles at <br />the moment.
        </div>
      </div>
      <!--paging-->
      <div class="col-xs-12  paging-custom " *ngIf="bookingData?.length > 0">
        <pagination-controls class="col-xs-12" *ngIf="totalItemsBooking > itemsPerPage"
          (pageChange)="pageChangeBooking($event)" previousLabel=" " nextLabel=" " id='booking'
          [maxSize]="maximumSize"></pagination-controls>
      </div>




    </div>


  </div>

</div>